import React from "react";
import "../styles/Footer.css"

const Footer = () => {
    return <p id="footer">Developed by Cetins</p>
}

export default Footer;